import React from 'react';
import { Listbox as HeadlessListbox } from '@headlessui/react';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';

interface ListboxOption {
  value: any;
  label: string;
  style?: React.CSSProperties;
}

interface ListboxProps {
  value: any;
  onChange: (value: any) => void;
  options: ListboxOption[];
  disabled?: boolean;
  placeholder?: string;
}

export default function Listbox({
  value,
  onChange,
  options,
  disabled,
  placeholder = 'Select an option',
}: ListboxProps) {
  const selectedOption = options.find(opt => opt.value === value);

  return (
    <HeadlessListbox value={value} onChange={onChange} disabled={disabled}>
      <div className="relative">
        <HeadlessListbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2.5 pl-4 pr-10 text-left border border-slate-200 hover:border-slate-300 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          <span className="block truncate text-slate-700">{selectedOption?.label || placeholder}</span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
            <ChevronUpDownIcon className="h-5 w-5 text-slate-400" />
          </span>
        </HeadlessListbox.Button>
        <HeadlessListbox.Options className="absolute z-10 mt-2 max-h-60 w-full overflow-auto rounded-xl bg-white shadow-xl border border-slate-200 py-2 text-base focus:outline-none ">
          {options.map((option, idx) => (
            <HeadlessListbox.Option
              key={idx}
              value={option.value}
              className={({ active }) =>
                `relative cursor-pointer select-none py-2.5 pl-10 pr-4 mx-2 rounded-lg transition-colors ${
                  active ? 'bg-slate-100 text-slate-900' : 'text-slate-700'
                }`
              }
            >
              {({ selected }) => (
                <>
                  <span className="block truncate" style={option.style}>
                    {option.label}
                  </span>
                  {selected && (
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-slate-600">
                      <CheckIcon className="h-5 w-5" />
                    </span>
                  )}
                </>
              )}
            </HeadlessListbox.Option>
          ))}
        </HeadlessListbox.Options>
      </div>
    </HeadlessListbox>
  );
}
